import {AuthService} from 'app/core/services/auth.service';
import {PosthogService} from 'app/core/services/analytics/posthog.service';
import {EnvName, getEnvName} from '../../../environments/env-name';
import {DemoService} from 'app/core/services/demo.service';

export function posthogInit(auth: AuthService, posthog: PosthogService, demo: DemoService) {
    return async () => {
        if (getEnvName() !== EnvName.Prod) {
            console.log('The posthog should be disabled');
            return;
        }
        if (demo.isDemoHost) {
            console.debug('The posthog should be disabled on demo');
            return;
        }
        const user = await auth.init();
        await posthog.init(user);
        auth.addAfterSignOutCallback(posthog.onSignOut);
    };
}
